import React, { FC, useState } from 'react';
import { useRouter } from 'next/router';
import PositionListArea from '@components/search/PositionListArea';
import KeywordFilter from '@components/search/KeywordFilter';
import CompanyListArea from '@components/search/CompanyListArea';
import SearchModal from './searchModal';
import classnames from 'classnames/bind';
import styles from './searchPage.module.scss';
const cx = classnames.bind(styles);

const Search: FC = () => {
  const { query } = useRouter();
  const keyword = query.keyword?.toString() ?? '';

  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleInputAreaClick = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <div className={cx('searchArea')}>
        <div className={cx('inputArea')} onClick={handleInputAreaClick}>
          <div className={cx('inputInner')}>
            <KeywordFilter queryKeyword={keyword} autoVisible shouldFocusOnMount={false} />
          </div>
        </div>
      </div>
      <CompanyListArea keyword={keyword} />
      <PositionListArea keyword={keyword} />
      {isModalVisible && <SearchModal onClose={handleCloseModal} />}
    </>
  );
};

export default Search;
